import { SessieChecker } from "../../../Syntess.Web.Shared/Utils/SessieChecker";
import { showAlert } from "../../../Syntess.Web.Shared/UI";

export class PortalSessieChecker extends SessieChecker {
    protected showRemoteIngelogdMelding(tekst: string): JQueryPromise<void> {
        const showing = $.Deferred<void>();
        showAlert(tekst).always(showing.resolve);
        return showing.promise();
    }
}
